import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import noResults15 from "../../assets/search-no-results-1.5x.png";
import noResults2 from "../../assets/search-no-results-2x.png";
import noResults3 from "../../assets/search-no-results-3x.png";
import noResults1 from "../../assets/search-no-results-1x.png";
import { FeedbackCheck } from "./FeedbackCheck";

interface Props {
  onReset?: () => void;
  noResultsText?: string;
  showFeedback?: boolean;
}

export const NoSearchResults = ({
  onReset,
  noResultsText,
  showFeedback = true,
}: Props): JSX.Element => {
  return (
    <Card>
      <CardContent
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          mt: 3,
          alignItems: "center",
        }}
      >
        <img
          srcSet={`${noResults15} 1.5x, ${noResults2} 2x, ${noResults3} 3x`}
          src={noResults1}
          alt="No search results"
          style={{ maxWidth: 477, width: "100%" }}
        />
        <Typography variant="h4" sx={{ my: 2, textAlign: "center" }}>
          {noResultsText ||
            "Sorry, no results. Please update your search and try again."}
        </Typography>
        {onReset && <Button onClick={onReset}>Reset Search</Button>}
        {showFeedback && (
          <FeedbackCheck
            screenName="FormsLibrary-NoSearchResults"
            questionText="Please send us a message and we'll help you locate the forms you’re looking for."
            buttonText="Message Atticus"
          />
        )}
      </CardContent>
    </Card>
  );
};
